exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Utility Classes */\r\n\r\n.d-flex {\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n  }\r\n  .space-between {\r\n    -ms-flex-pack: justify;\r\n        justify-content: space-between;\r\n  }\r\n  .mb-0 {\r\n    margin-bottom: 0;\r\n  }\r\n  .pl-0 {\r\n    padding-left: 0;\r\n  }\r\n  .mt-10 {\r\n    margin-top: 10px;\r\n  }\r\n  .mr-10 {\r\n    margin-right: 10px;\r\n  }\r\n  .no-space-wrap {\r\n    word-break: break-all;\r\n  }", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// G:/UTL/BMI/Admin/Admin-ANG/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!G:/UTL/BMI/Admin/Admin-ANG/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!G:/UTL/BMI/Admin/Admin-ANG/src/assets/css/utility.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../../src/assets/css/utility.css
// module chunks = styles